export const STICKY_CARD_HEADER_CLASS = 'sticky top-app-header z-10 bg-card';
